import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import ContentStickyNavigations from './content-sticky-navigations/ContentStickyNavigations'
import HomepageCategory from './home-page-category/HomepageCategory'
import HomepageJustForYou from './home-page-just-for-you/HomepageJustForYou'
import HomepageBestSellers from './home-page-best-sellers/HomepageBestSellers'

const HomepageContent = ({ selectedTopNavigation }) => {
  const renderContent = () => {
    switch (selectedTopNavigation?.attributes?.sub_type) {
      case 'category':
        return <HomepageCategory />
      case 'best-sellers':
        return <HomepageBestSellers />
      case 'for-you':
        return <HomepageJustForYou />
      default:
        return <HomepageCategory />
    }
  }

  return (
    <React.Fragment>
      <ContentStickyNavigations />
      {renderContent()}
    </React.Fragment>
  )
}

HomepageContent.defaultProps = {
  selectedTopNavigation: null,
}

HomepageContent.propTypes = {
  selectedTopNavigation: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    attributes: PropTypes.shape({ sub_type: PropTypes.string }),
  }),
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
    selectedTopNavigation: state.homePage.selectedTopNavigation,
  })),
  withI18next(),
)(HomepageContent)
